import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const MCPServersSchema = Yup.object().shape({
  server_name: Yup.string().trim().required('Server Name is required'),
});

export { MCPServersSchema };
